import { render, staticRenderFns } from "./EditNormal.vue?vue&type=template&id=5859f605&scoped=true&"
import script from "./EditNormal.vue?vue&type=script&lang=js&"
export * from "./EditNormal.vue?vue&type=script&lang=js&"
import style0 from "./EditNormal.vue?vue&type=style&index=0&id=5859f605&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859f605",
  null
  
)

export default component.exports